import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CategoryListLayer from "../components/CategoryListLayer";

export const CategoryListPage = () => {
  return (
    <MasterLayout>
      <CategoryListLayer />
    </MasterLayout>
  );
};
